window.PreVenda = Backbone.Model.extend({

});

window.PreVendas = Backbone.Collection.extend({
    model: PreVenda
});